import React, { useEffect, useRef, useState } from 'react';
import { supabase } from './supabase';

// Cierra la sesión tras 1 hora sin actividad (clics, teclado, toque o scroll),
// con un aviso 5 minutos antes. La última actividad se guarda en localStorage
// para que cuente entre pestañas y para detectar una computadora que estuvo
// dormida o con la pestaña cerrada.
export const LIMITE_INACTIVIDAD_MS = 60 * 60 * 1000;
const AVISO_ANTES_MS = 5 * 60 * 1000;
export const CLAVE_ULTIMA_ACTIVIDAD = 'crm_ultima_actividad';
export const CLAVE_SESION_EXPIRADA = 'crm_sesion_expirada';

const leerUltima = () => {
  try {
    const v = parseInt(localStorage.getItem(CLAVE_ULTIMA_ACTIVIDAD), 10);
    return Number.isFinite(v) ? v : null;
  } catch (e) { return null; }
};

export default function InactividadSesion() {
  const [segundosRestantes, setSegundosRestantes] = useState(null);
  const ultimaRef = useRef(Date.now());
  const ultimaGuardadoRef = useRef(0);

  const marcarActividad = () => {
    const ahora = Date.now();
    ultimaRef.current = ahora;
    if (ahora - ultimaGuardadoRef.current > 15000) {
      ultimaGuardadoRef.current = ahora;
      try { localStorage.setItem(CLAVE_ULTIMA_ACTIVIDAD, String(ahora)); } catch (e) { /* sin almacenamiento */ }
    }
  };

  useEffect(() => {
    const guardada = leerUltima();
    if (guardada) ultimaRef.current = guardada;
    else marcarActividad();

    let cerrando = false;
    const cerrar = async () => {
      if (cerrando) return;
      cerrando = true;
      try {
        localStorage.setItem(CLAVE_SESION_EXPIRADA, '1');
        localStorage.removeItem(CLAVE_ULTIMA_ACTIVIDAD);
      } catch (e) { /* sin almacenamiento */ }
      await supabase.auth.signOut();
    };

    const revisar = () => {
      const ultima = Math.max(ultimaRef.current, leerUltima() || 0);
      const inactivo = Date.now() - ultima;
      if (inactivo >= LIMITE_INACTIVIDAD_MS) { cerrar(); return; }
      if (inactivo >= LIMITE_INACTIVIDAD_MS - AVISO_ANTES_MS) {
        setSegundosRestantes(Math.max(1, Math.ceil((LIMITE_INACTIVIDAD_MS - inactivo) / 1000)));
      } else {
        setSegundosRestantes(null);
      }
    };

    const eventos = ['mousedown', 'keydown', 'touchstart', 'scroll', 'wheel'];
    eventos.forEach(ev => window.addEventListener(ev, marcarActividad, { passive: true, capture: true }));
    const alVolver = () => { if (document.visibilityState === 'visible') revisar(); };
    document.addEventListener('visibilitychange', alVolver);
    window.addEventListener('focus', revisar);
    const intervalo = setInterval(revisar, 15000);
    revisar();

    return () => {
      eventos.forEach(ev => window.removeEventListener(ev, marcarActividad, { capture: true }));
      document.removeEventListener('visibilitychange', alVolver);
      window.removeEventListener('focus', revisar);
      clearInterval(intervalo);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (segundosRestantes === null) return null;

  const mm = Math.floor(segundosRestantes / 60);
  const ss = String(segundosRestantes % 60).padStart(2, '0');

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 5000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ background: '#fff', borderRadius: '12px', padding: '1.5rem', maxWidth: '360px', width: '100%', textAlign: 'center' }}>
        <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a2e', marginBottom: '8px' }}>¿Sigues ahí?</div>
        <div style={{ fontSize: '13px', color: '#666', marginBottom: '16px', lineHeight: '1.5' }}>
          Por inactividad, tu sesión se cerrará en <strong>{mm}:{ss}</strong>.
        </div>
        <button onClick={() => { marcarActividad(); setSegundosRestantes(null); }}
          style={{ padding: '10px 24px', background: '#4A4A4A', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}>
          Seguir conectado
        </button>
      </div>
    </div>
  );
}
